var s = {"box":"Popper_box_ib2cl_81"};

export { s as default };
//# sourceMappingURL=index.module.scss.js.map
